<template>
  <div class="box">

    <div class="handle-box-search">

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 90px;text-align: right;margin-right: 5px;">模式:</span>
        <el-select v-model="submit_data.order_time" placeholder="请选择模式" style="width: 200px; margin-right: 20px;"
                   clearable>
          <el-option label="下单时间" value="order_time_stamp"></el-option>
          <el-option label="服务完成时间" value="end_time_stamp"></el-option>
          <el-option label="订单支付时间(结束)" value="pay_time_stamp"></el-option>
        </el-select>


      </el-row>

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 90px;text-align: right;margin-right: 5px;">订单类型:</span>
        <el-select v-model="submit_data.type" placeholder="请选择模式" style="width: 200px; margin-right: 20px;"
                   clearable>
          <el-option label="当前订单" value="0"></el-option>
          <el-option label="历史订单" value="1"></el-option>
          <el-option label="全部当前订单" value="2"></el-option>
          <el-option label="全部历史订单" value="3"></el-option>
        </el-select>


      </el-row>

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">时间:</span>
        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                        style="width: 200px;">
        </el-date-picker>



      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">密码:</span>
        <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>



      </el-row>





      <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

        <el-progress :percentage="progress_data"></el-progress>
        <i class="el-icon-loading"></i>
        正在导出...

      </div>

      <el-row type="flex" justify="center" v-else>

        <el-button type="primary" @click="toExport">导出司机业绩</el-button>


      </el-row>



    </div>




  </div>

</template>

<script>
  var _this;
  export default {

    data() {
      return {


        submit_data: {
          page: 1,
          type: '',
          order_time: '',
          fixed_array:'',
          export_password:''
        },

        search_time:'',

        excelData: [],

        excelHead: [],

        progress_show: false,
        progress_data: 0

      };
    },
    created() {
      _this = this;
      console.log(this.$route.path);

    },

    methods: {
      timeChange(val) {
        if(val!=null){
          _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));

        }else{
          _this.submit_data.fixed_array = ''
        }

      },
      toExport() {


        _this.getExcelData();

      },

      getExcelData() {

        _this.$post(
          "/driver/getPerformanceCSV",
          _this.submit_data
        ).then(res => {

          _this.progress_show = true;

          if (this.$route.path == '/getPerformanceCSV') {

            if (res.data.page * res.data.limit < res.data.count) {

              _this.submit_data.page = res.data.page + 1;
              _this.submit_data.data = JSON.stringify(res.data.list);

              _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

              _this.getExcelData();

            } else {




              for (let i = 0; i < res.data.list.length; i++) {

                _this.excelData.push({
                    'name': res.data.list[i].name,

                  });

                for (const key in res.data.list[i]) {


                  if (key != 'name') {
                    for (const p in res.data.list[i][key]){

                      _this.excelData.push(res.data.list[i][key][p]);

                    }


                  }

                }

              }


              // console.log(_this.excelData);

              // 将数据导出execl
              _this.exportData();

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;
              _this.progress_data = 0;


            }

          } else {

            _this.progress_show = false;
            _this.progress_data = 0;

          }



        }).catch((err) => {



        })

      },


      // 导出excel方法
      exportData() {
        const {
          export_json_to_excel
        } = require('@/vendor/Export2Excel');
        const tHeader = ['','司机名字', '订单合计', '金额合计'];
        const filterVal = ['name','real_name', 'count', 'total'];
        const list = this.excelData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'fileName');
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },



    }
  };
</script>

<style scoped>

</style>